(() => {
  'use strict';
  const root = document.documentElement;
  const live = () => document.getElementById('VemorayLiveRegion');
  const announce = message => { if (live()) live().textContent = message; };
  const escapeHtml = value => String(value ?? '').replace(/[&<>'"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));
  const formatMoney = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', { style:'currency', currency: window.Vemoray.currency }).format((Number(cents) || 0) / 100);
  const debounce = (fn, wait = 250) => { let timer; return (...args) => { clearTimeout(timer); timer = setTimeout(() => fn(...args), wait); }; };

  function focusable(container) {
    return [...container.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter(el => !el.hidden && el.offsetParent !== null);
  }

  let activeDrawer = null;
  let returnFocus = null;
  function openDrawer(drawer) {
    if (!drawer) return;
    if (activeDrawer && activeDrawer !== drawer) closeDrawer(activeDrawer, false);
    returnFocus = document.activeElement;
    activeDrawer = drawer;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    const first = focusable(drawer)[0];
    if (first) requestAnimationFrame(() => first.focus());
  }
  function closeDrawer(drawer = activeDrawer, restore = true) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
    activeDrawer = null;
    if (restore && returnFocus) returnFocus.focus();
  }
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-drawer-open]');
    if (opener) { event.preventDefault(); openDrawer(document.getElementById(opener.dataset.drawerOpen)); return; }
    const closer = event.target.closest('[data-drawer-close]');
    if (closer) { event.preventDefault(); closeDrawer(closer.closest('.drawer')); }
    const modalOpen = event.target.closest('[data-modal-open]');
    if (modalOpen) { event.preventDefault(); openModal(document.getElementById(modalOpen.dataset.modalOpen), modalOpen.dataset.mediaId); }
    const modalClose = event.target.closest('[data-modal-close]');
    if (modalClose) closeModal(modalClose.closest('.product-modal'));
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      if (activeDrawer) closeDrawer();
      const modal = document.querySelector('.product-modal.is-open');
      if (modal) closeModal(modal);
    }
    if (event.key === 'Tab' && activeDrawer) {
      const items = focusable(activeDrawer); if (!items.length) return;
      const first = items[0], last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });

  function openModal(modal, mediaId) {
    if (!modal) return;
    returnFocus = document.activeElement;
    modal.classList.add('is-open'); modal.setAttribute('aria-hidden','false');
    document.body.classList.add('drawer-open');
    if (mediaId) modal.querySelectorAll('[data-modal-media]').forEach(el => el.hidden = el.dataset.modalMedia !== mediaId);
    modal.querySelector('[data-modal-close]')?.focus();
  }
  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open'); modal.setAttribute('aria-hidden','true');
    document.body.classList.remove('drawer-open'); returnFocus?.focus();
  }

  document.querySelectorAll('[data-announcement]').forEach(bar => {
    const messages = [...bar.querySelectorAll('[data-announcement-message]')];
    if (messages.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let index = 0;
    setInterval(() => { messages[index].classList.remove('is-active'); index = (index + 1) % messages.length; messages[index].classList.add('is-active'); }, Number(bar.dataset.speed || 5) * 1000);
  });

  document.querySelectorAll('[data-carousel]').forEach(carousel => {
    const track = carousel.querySelector('[data-carousel-track]');
    carousel.querySelectorAll('[data-carousel-direction]').forEach(button => button.addEventListener('click', () => {
      const direction = button.dataset.carouselDirection === 'next' ? 1 : -1;
      track.scrollBy({ left: direction * Math.max(track.clientWidth * .82, 280), behavior:'smooth' });
    }));
  });

  document.querySelectorAll('[data-predictive-search]').forEach(container => {
    const input = container.querySelector('input[type="search"]');
    const output = container.querySelector('[data-predictive-results]');
    if (!input || !output) return;
    const search = debounce(async () => {
      const query = input.value.trim();
      if (query.length < 2) { output.innerHTML = ''; return; }
      output.setAttribute('aria-busy','true');
      try {
        const url = `${window.Vemoray.routes.predictive}?q=${encodeURIComponent(query)}&resources[type]=product,collection,page,article&resources[limit]=6&resources[options][unavailable_products]=last`;
        const response = await fetch(url, { headers:{ Accept:'application/json' } });
        if (!response.ok) throw new Error('Search failed');
        const results = (await response.json()).resources.results;
        const products = results.products || [];
        const secondary = [...(results.collections || []), ...(results.pages || []), ...(results.articles || [])];
        let html = '';
        if (products.length) html += `<div class="predictive-search__group"><h3>Products</h3><div class="predictive-search__grid">${products.map(p => `<a class="predictive-search__item" href="${escapeHtml(p.url)}">${window.Vemoray.showSearchImages && p.featured_image?.url ? `<img src="${escapeHtml(p.featured_image.url)}&width=128" alt="${escapeHtml(p.featured_image.alt || p.title)}" width="64" height="64">` : ''}<span><strong>${escapeHtml(p.title)}</strong><br><span class="muted">${formatMoney(p.price)}</span></span></a>`).join('')}</div></div>`;
        if (secondary.length) html += `<div class="predictive-search__group"><h3>Explore</h3><ul>${secondary.map(item => `<li><a href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a></li>`).join('')}</ul></div>`;
        if (!html) html = `<p class="muted">No suggestions found.</p>`;
        html += `<a class="button button--text" href="${window.Vemoray.routes.root}search?q=${encodeURIComponent(query)}">View all results</a>`;
        output.innerHTML = html;
      } catch (_) { output.innerHTML = '<p class="muted">Search is temporarily unavailable.</p>'; }
      finally { output.removeAttribute('aria-busy'); }
    }, 220);
    input.addEventListener('input', search);
  });

  async function refreshCartDrawer(open = false) {
    if (window.Vemoray.cartType !== 'drawer') return;
    const response = await fetch(`${window.Vemoray.routes.cart}?section_id=cart-drawer`, { headers:{ Accept:'text/html' } });
    if (!response.ok) return;
    const html = await response.text();
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const next = parsed.querySelector('[data-cart-drawer-section]');
    const current = document.querySelector('[data-cart-drawer-section]');
    if (next && current) current.replaceWith(next);
    if (open) openDrawer(document.getElementById('CartDrawer'));
  }
  function updateCartCounts(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = count; el.hidden = count < 1; });
  }
  async function postCart(url, body) {
    const response = await fetch(url, { method:'POST', headers:{ Accept:'application/json' }, body });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Cart request failed');
    return data;
  }
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-product-form]');
    if (!form || event.submitter?.name === 'checkout') return;
    event.preventDefault();
    const button = form.querySelector('[name="add"]');
    const error = form.querySelector('[data-product-error]');
    if (button) { button.disabled = true; button.setAttribute('aria-busy','true'); }
    if (error) { error.hidden = true; error.textContent = ''; }
    try {
      const item = await postCart(window.Vemoray.routes.cartAdd, new FormData(form));
      const cart = await fetch(`${window.Vemoray.routes.cart}.js`).then(r => r.json());
      updateCartCounts(cart.item_count); announce(`${item.product_title || 'Item'} added to cart.`);
      if (window.Vemoray.cartType === 'drawer') await refreshCartDrawer(true); else window.location.assign(window.Vemoray.routes.cart);
    } catch (err) { if (error) { error.textContent = err.message; error.hidden = false; } announce(err.message); }
    finally { if (button) { button.disabled = false; button.removeAttribute('aria-busy'); } }
  });
  document.addEventListener('click', async event => {
    const quantityButton = event.target.closest('[data-quantity-change]');
    if (quantityButton) {
      const wrap = quantityButton.closest('[data-quantity]');
      const input = wrap.querySelector('input');
      const next = Math.max(Number(input.min || 0), Number(input.value || 0) + Number(quantityButton.dataset.quantityChange));
      input.value = next; input.dispatchEvent(new Event('change', { bubbles:true }));
    }
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) { event.preventDefault(); await changeCartLine(remove.dataset.cartRemove, 0, remove); }
  });
  document.addEventListener('change', event => {
    const input = event.target.closest('[data-cart-quantity]');
    if (input) changeCartLine(input.dataset.cartQuantity, Number(input.value), input);
  });
  async function changeCartLine(line, quantity, control) {
    control.disabled = true;
    try {
      const body = new FormData(); body.append('line', line); body.append('quantity', quantity);
      const cart = await postCart(window.Vemoray.routes.cartChange, body);
      updateCartCounts(cart.item_count); announce(window.Vemoray.strings.cartUpdated);
      if (control.closest('#CartDrawer')) await refreshCartDrawer(true); else window.location.reload();
    } catch (err) { announce(err.message); control.disabled = false; }
  }

  document.querySelectorAll('[data-product-root]').forEach(productRoot => {
    const dataNode = productRoot.querySelector('[data-product-json]');
    if (!dataNode) return;
    const product = JSON.parse(dataNode.textContent);
    const form = productRoot.querySelector('[data-main-product-form]');
    const idInput = form?.querySelector('[name="id"]');
    const optionInputs = [...productRoot.querySelectorAll('[data-option-input]')];
    const price = productRoot.querySelector('[data-product-price]');
    const compare = productRoot.querySelector('[data-product-compare]');
    const add = form?.querySelector('[name="add"]');
    const save = productRoot.querySelector('[data-product-save]');
    const availableLabel = add?.dataset.availableLabel || window.Vemoray.strings.addToCart;
    function currentOptions() {
      const values = [];
      product.options.forEach((_, i) => {
        const selected = optionInputs.find(el => Number(el.dataset.optionPosition) === i + 1 && ((el.type === 'radio' && el.checked) || el.tagName === 'SELECT'));
        values.push(selected?.value);
      }); return values;
    }
    function displayOptionValue(value) { return value || ''; }
    function updateVariant() {
      const values = currentOptions();
      values.forEach((value, index) => { const label = productRoot.querySelector(`[data-option-value="${index + 1}"]`); if (label) label.textContent = displayOptionValue(value); });
      const variant = product.variants.find(v => v.options.every((option,i) => option === values[i]));
      if (!variant) { if (add) { add.disabled = true; add.textContent = window.Vemoray.strings.unavailable; } return; }
      if (idInput) idInput.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price);
      if (compare) { compare.textContent = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : ''; compare.hidden = !(variant.compare_at_price > variant.price); }
      if (save) { const percent = variant.compare_at_price > variant.price ? Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100) : 0; save.hidden = percent < 1; save.textContent = `${save.dataset.label} ${percent}%`; }
      if (add) { add.disabled = !variant.available; add.textContent = variant.available ? availableLabel : window.Vemoray.strings.soldOut; }
      const sticky = document.querySelector('[data-sticky-atc]');
      if (sticky) { sticky.querySelector('[data-product-price]').textContent = formatMoney(variant.price); const stickyButton = sticky.querySelector('button'); stickyButton.disabled = !variant.available; stickyButton.textContent = variant.available ? availableLabel : window.Vemoray.strings.soldOut; }
      if (history.replaceState) history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
      if (variant.featured_media) activateMedia(String(variant.featured_media.id));
    }
    optionInputs.forEach(input => input.addEventListener('change', updateVariant));
    const slides = [...productRoot.querySelectorAll('[data-media-slide]')];
    const thumbs = [...productRoot.querySelectorAll('[data-media-thumb]')];
    function activateMedia(id) {
      const requestedIndex = slides.findIndex(slide => slide.dataset.mediaSlide === id);
      if (requestedIndex < 0) return;
      slides.forEach(slide => slide.classList.toggle('is-active', slide.dataset.mediaSlide === id));
      thumbs.forEach(thumb => { const active = thumb.dataset.mediaThumb === id; thumb.classList.toggle('is-active', active); thumb.setAttribute('aria-current', active ? 'true' : 'false'); });
      const activeIndex = slides.findIndex(slide => slide.dataset.mediaSlide === id);
      const counter = productRoot.querySelector('[data-gallery-current]');
      if (counter && activeIndex >= 0) counter.textContent = String(activeIndex + 1);
      thumbs[activeIndex]?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'nearest', inline:'center' });
    }
    thumbs.forEach(thumb => thumb.addEventListener('click', () => activateMedia(thumb.dataset.mediaThumb)));
    productRoot.querySelectorAll('[data-gallery-direction]').forEach(button => button.addEventListener('click', () => {
      const current = slides.findIndex(slide => slide.classList.contains('is-active'));
      const offset = button.dataset.galleryDirection === 'next' ? 1 : -1;
      const next = (current + offset + slides.length) % slides.length;
      if (slides[next]) activateMedia(slides[next].dataset.mediaSlide);
    }));
    const galleryStage = productRoot.querySelector('[data-gallery-stage]');
    if (galleryStage && slides.length > 1) {
      let touchStart = 0;
      galleryStage.addEventListener('touchstart', event => { touchStart = event.changedTouches[0].clientX; }, { passive:true });
      galleryStage.addEventListener('touchend', event => {
        const delta = event.changedTouches[0].clientX - touchStart;
        if (Math.abs(delta) < 45) return;
        const current = slides.findIndex(slide => slide.classList.contains('is-active'));
        const next = (current + (delta < 0 ? 1 : -1) + slides.length) % slides.length;
        activateMedia(slides[next].dataset.mediaSlide);
      }, { passive:true });
    }
    const stickyBar = document.querySelector('[data-sticky-atc]');
    if (stickyBar && form && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting), { threshold:.15 });
      observer.observe(form);
    } else if (stickyBar) stickyBar.classList.add('is-visible');
  });

  document.querySelectorAll('[data-delivery-timeline]').forEach(timeline => {
    const now = new Date();
    const ready = new Date(now); ready.setDate(ready.getDate() + Number(timeline.dataset.processingDays || 2));
    const delivered = new Date(now); delivered.setDate(delivered.getDate() + Number(timeline.dataset.deliveryDays || 8));
    const formatter = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { month:'short', day:'numeric' });
    const orderNode = timeline.querySelector('[data-order-date]');
    const readyNode = timeline.querySelector('[data-ready-date]');
    const deliveryNode = timeline.querySelector('[data-delivery-date]');
    if (orderNode) orderNode.textContent = formatter.format(now);
    if (readyNode) readyNode.textContent = formatter.format(ready);
    if (deliveryNode) deliveryNode.textContent = formatter.format(delivered);
  });

  document.querySelectorAll('[data-grid-view]').forEach(button => button.addEventListener('click', () => {
    const grid = document.querySelector('[data-product-grid]'); if (!grid) return;
    grid.classList.toggle('is-list', button.dataset.gridView === 'list');
    localStorage.setItem('vemoray-grid-view', button.dataset.gridView);
  }));
  const savedView = localStorage.getItem('vemoray-grid-view');
  if (savedView === 'list') document.querySelector('[data-product-grid]')?.classList.add('is-list');
  document.querySelectorAll('[data-sort-by]').forEach(select => select.addEventListener('change', () => {
    const url = new URL(location.href); url.searchParams.set('sort_by', select.value); location.assign(url.toString());
  }));
  document.querySelectorAll('[data-facet-form]').forEach(form => form.addEventListener('change', debounce(() => form.submit(), 350)));

  document.querySelectorAll('[data-load-more]').forEach(button => button.addEventListener('click', async () => {
    button.disabled = true; button.setAttribute('aria-busy','true');
    try {
      const response = await fetch(button.dataset.loadMore); const html = await response.text();
      const parsed = new DOMParser().parseFromString(html,'text/html');
      const items = parsed.querySelectorAll('[data-product-grid] > *');
      document.querySelector('[data-product-grid]').append(...items);
      const next = parsed.querySelector('[data-load-more]');
      if (next) button.dataset.loadMore = next.dataset.loadMore; else button.remove();
    } catch (_) { button.disabled = false; button.removeAttribute('aria-busy'); }
  }));

  const productHandle = document.body.dataset.productHandle;
  if (productHandle) {
    const history = JSON.parse(localStorage.getItem('vemoray-recent') || '[]').filter(h => h !== productHandle);
    history.unshift(productHandle); localStorage.setItem('vemoray-recent', JSON.stringify(history.slice(0,8)));
  }
  document.querySelectorAll('[data-recently-viewed]').forEach(async section => {
    const exclude = section.dataset.exclude;
    const handles = JSON.parse(localStorage.getItem('vemoray-recent') || '[]').filter(h => h !== exclude).slice(0, Number(section.dataset.limit || 4));
    if (!handles.length) return;
    const grid = section.querySelector('[data-recent-grid]');
    const products = (await Promise.all(handles.map(h => fetch(`${window.Vemoray.routes.root}products/${encodeURIComponent(h)}.js`).then(r => r.ok ? r.json() : null).catch(() => null)))).filter(Boolean);
    if (!products.length) return;
    grid.innerHTML = products.map(p => `<article class="product-card"><a class="product-card__media" href="${window.Vemoray.routes.root}products/${escapeHtml(p.handle)}">${p.featured_image ? `<img src="${escapeHtml(p.featured_image)}&width=700" alt="${escapeHtml(p.title)}" width="700" height="700" loading="lazy">` : ''}</a><div class="product-card__info"><h3 class="product-card__title"><a href="${window.Vemoray.routes.root}products/${escapeHtml(p.handle)}">${escapeHtml(p.title)}</a></h3><div class="price">${formatMoney(p.price)}</div></div></article>`).join('');
    section.hidden = false;
  });

  document.querySelectorAll('[data-share]').forEach(button => button.addEventListener('click', async () => {
    if (navigator.share) await navigator.share({ title:document.title, url:location.href });
    else { await navigator.clipboard.writeText(location.href); announce('Link copied.'); }
  }));

  document.querySelectorAll('[data-product-recommendations]').forEach(async section => {
    const id = section.dataset.productId;
    if (!id) return;
    const url = `${window.Vemoray.routes.root}recommendations/products?section_id=${encodeURIComponent(section.dataset.sectionId)}&product_id=${encodeURIComponent(id)}&limit=${encodeURIComponent(section.dataset.limit)}&intent=related`;
    try {
      const html = await fetch(url).then(r => r.text());
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const next = parsed.querySelector('[data-product-recommendations]');
      if (next?.innerHTML.trim()) section.replaceWith(next);
      else section.remove();
    } catch (_) { section.remove(); }
  });
})();
